var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-Report"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Report",
    clipPath: "url(#clip-Report)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Document",
    transform: "translate(2 1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    d: "M8.839,0a3.44,3.44,0,0,1,3.6,3.668v6.3a3.406,3.406,0,0,1-3.571,3.666l-5.268,0A3.441,3.441,0,0,1,0,9.965v-6.3A3.4,3.4,0,0,1,3.571,0L8.838,0Zm0,1.027-5.265,0A2.393,2.393,0,0,0,1.027,3.668v6.3A2.4,2.4,0,0,0,3.6,12.606l5.265,0a2.394,2.394,0,0,0,2.547-2.639v-6.3A2.4,2.4,0,0,0,8.839,1.027Zm-.132,8.2a.514.514,0,1,1,0,1.027H3.763a.514.514,0,1,1,0-1.027Zm0-2.867a.514.514,0,1,1,0,1.027H3.763a.514.514,0,1,1,0-1.027ZM5.649,3.5a.514.514,0,1,1,0,1.027H3.763a.514.514,0,1,1,0-1.027Z",
    transform: "translate(0 0)",
    fill: "#a2a2a2",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport);
export default __webpack_public_path__ + "static/media/Report.11288f1a3790cef5bb45834667e136a3.svg";
export { ForwardRef as ReactComponent };